export default __webpack_public_path__ + "static/media/right-tic.881b635d.svg";